import $ from 'jquery';

const teamListing = {
  initCanvasNavigation: () => {
    // set up previous / next clicks
    $('.team-navigation .prev').on('click', function () {
      $(this).parents('.team-card').prev().find('.team-image-container').trigger('click');
    });

    $('.team-navigation .next').on('click', function () {
      $(this).parents('.team-card').next().find('.team-image-container').trigger('click');
    });
  },
};

export default teamListing;
